// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2314":"aae53fedba9f423e","91812":"f6b62a6c4aee9358"}[chunkId] + ".css";
};